import React, { useContext, useEffect, useState, useMemo } from 'react';
import styles from './ProfileSubscriptionStatus.module.css';
import { fetchPaymentHistory, fetchSubscriptionUrl } from '../../../services';
import { dataContext } from '../../../App';
import { formatDateTime } from '../ReferralHistory/dateFormatter';

const ProfileSubscriptionStatus = ({ 
  isSubscribe, 
  isSubscribeTournament, 
  isSubscribeBcs, 
  isSubscribeSports, 
  setShowLoginModal, 
  setShowOtpModal, 
  setShowRefundModal 
}) => {
  const { token, playerData } = useContext(dataContext);
  const [activeTab, setActiveTab] = useState('active');
  const [dailyPayment, setDailyPayment] = useState({});
  const [sportsPayment, setSportsPayment] = useState({});
  const [tournamentPayment, setTournamentPayment] = useState({});
  const [bcsPayment, setBcsPayment] = useState({});

  useEffect(() => {
    fetchPaymentHistory(token).then((res) => {
      // Helper to get latest payment by service_type
      function getLatestPayment(serviceType) {
        const filtered = res.filter(
          (item) => item.serviceType === serviceType
        );
        if (filtered.length === 0) return {};
        // Sort by payment_date descending
        filtered.sort(
          (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate)
        );
        return filtered[0];
      }

      setDailyPayment(getLatestPayment("Daily"));
      setSportsPayment(getLatestPayment("Sports"));
      setTournamentPayment(getLatestPayment("Tournament"));
      setBcsPayment(getLatestPayment("BCS"));
    });
  }, [token]);

  function handleSubscriptionClick(service_type) {
    if (!playerData?.id) {
      setShowLoginModal(true);
      return;
    }
    fetchSubscriptionUrl(token, service_type)
      .then((res) => {
        setShowOtpModal(true);
      });
  }

  function handleUnSubscriptionClick(service_type) {
    sessionStorage.setItem('unsubsServiceType', service_type);
    setShowRefundModal(true);
  }

  // Create subscription data array
  const subscriptionData = useMemo(() => [
    {
      id: 'daily',
      type: 'Daily',
      title: 'কুইজ প্রতিদিন সাবস্ক্রিপশন',
      background: '#12793C',
      isSubscribed: isSubscribe,
      payment: dailyPayment,
      feature: 'প্রতিদিন ২ রাউন্ড কুইজ প্রতিদিন'
    },
    {
      id: 'tournament',
      type: 'Tournament',
      title: 'টুর্নামেন্ট সাবস্ক্রিপশন',
      background: '#0081DC',
      isSubscribed: isSubscribeTournament,
      payment: tournamentPayment,
      feature: 'সকল টুর্নামেন্টে অংশগ্রহণ'
    },
    {
      id: 'sports',
      type: 'Sports',
      title: 'স্পোর্টস সাবস্ক্রিপশন',
      background: '#008080',
      isSubscribed: isSubscribeSports,
      payment: sportsPayment,
      feature: 'সকল স্পোর্টস কুইজে অংশগ্রহণ'
    },
    {
      id: 'bcs',
      type: 'BCS',
      title: 'বিসিএস সাবস্ক্রিপশন',
      background: '#b54a8b',
      isSubscribed: isSubscribeBcs,
      payment: bcsPayment,
      feature: 'প্রতিদিন ২ রাউন্ড বিসিএস কুইজ'
    }
  ], [
    isSubscribe, isSubscribeTournament, isSubscribeSports, isSubscribeBcs,
    dailyPayment, tournamentPayment, sportsPayment, bcsPayment
  ]);

  // Filter active subscriptions
  const activeSubscriptions = useMemo(() => 
    subscriptionData.filter(sub => sub.isSubscribed),
  [subscriptionData]);

  // Filter unsubscribed packages for the 'অন্যান্য প্যাকেজ' tab
  const unsubscribedPackages = useMemo(() => 
    subscriptionData.filter(sub => !sub.isSubscribed),
  [subscriptionData]);

  // Sort subscriptions: subscribed first, then unsubscribed (for All Packages tab)
  const sortedSubscriptions = useMemo(() => 
    [...subscriptionData].sort((a, b) => {
      if (a.isSubscribed && !b.isSubscribed) return -1;
      if (!a.isSubscribed && b.isSubscribed) return 1;
      return 0;
    }), 
  [subscriptionData]);

  return (
    <div className={styles.subscriptionContainer}>
      <h2 className={styles.title}>সাবস্ক্রিপশন</h2>
      
      <div className={styles.tabContainer}>
        <div 
          className={`${styles.tab} ${activeTab === 'active' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('active')}
        >
          একটিভ সাবস্ক্রিপশন
        </div>
        <div 
          className={`${styles.tab} ${activeTab === 'all' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('all')}
        >
          অন্যান্য প্যাকেজ
        </div>
      </div>
      
      {activeTab === 'active' && (
        <>
          {activeSubscriptions.length === 0 ? (
            <div className={styles.emptyMessage}>
              বর্তমানে কোনো সাবস্ক্রিপশন বা প্যাকেজ একটিভ নেই।
            </div>
          ) : (
            activeSubscriptions.map((subscription, index) => (
              <div 
                key={subscription.id} 
                className={styles.subscriptionBox} 
                style={index === activeSubscriptions.length - 1 ? {marginBottom: '0px'} : {}}
              >
                <div className={styles.header}>
                  <span className={styles.type} style={{background: subscription.background}}>
                    {subscription.title}
                  </span>
                  <span className={styles.badge}>সাবস্ক্রাইবড</span>
                </div>
                
                <div className={styles.price}>
                  <span className={styles.amount}>৳৩০</span>
                  <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
                  <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
                  {subscription.payment?.paymentDate && (
                    <>
                      <br /><span style={{fontSize:'14px'}}>Payment Date: {formatDateTime(subscription.payment.paymentDate)}</span>
                      <br /><span style={{fontSize:'14px'}}>Next Payment Date: {formatDateTime(subscription.payment.nextPaymentDate)}</span>
                    </>
                  )}
                </div>

                <div className={styles.features}>
                  <div className={styles.feature}>{subscription.feature}</div>
                </div>
                
                <button 
                  className={styles.unsubscribeButton} 
                  onClick={() => handleUnSubscriptionClick(subscription.type)}
                >
                  আনসাবস্ক্রাইব করুন
                </button>
              </div>
            ))
          )}
        </>
      )}
      
      {activeTab === 'all' && (
        unsubscribedPackages.map((subscription, index) => (
          <div 
            key={subscription.id} 
            className={styles.subscriptionBox} 
            style={index === unsubscribedPackages.length - 1 ? {marginBottom: '0px'} : {}}
          >
            <div className={styles.header}>
              <span className={styles.type} style={{background: subscription.background}}>
                {subscription.title}
              </span>
              {/* Only show badge if subscribed, which won't happen here */}
            </div>
            
            <div className={styles.price}>
              <span className={styles.amount}>৳৩০</span>
              <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
              <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
            </div>

            <div className={styles.features}>
              <div className={styles.feature}>{subscription.feature}</div>
            </div>
            
            <button 
              className={styles.subscribeButton} 
              onClick={() => handleSubscriptionClick(subscription.type)}
            >
              সাবস্ক্রাইব করুন
            </button>
          </div>
        ))
      )}
    </div>
  );
};

export default ProfileSubscriptionStatus;